import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { get } from 'lodash-es';

@Component({
  selector: 'app-grid-cell-editor',
  templateUrl: './grid-cell-editor.component.html',
  styleUrls: ['./grid-cell-editor.component.scss']
})
export class GridCellEditorComponent implements OnInit , ICellRendererAngularComp {
  cellValue: any;
  params: any;
  isInvalid: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  agInit(params: any): void {
    this.params = params;
    this.cellValue = params.value || "";
    this.validateCell();
  }

  refresh(params: any): boolean {
    this.cellValue = params.value || "";
    this.validateCell();
    return true;
  }

  onModelChange() {
    this.params.node.setDataValue(get(this.params, 'colDef.field'), this.cellValue);
    this.validateCell();
    if (this.params?.context && this.params?.context?.onCellValidationChange) {
      this.params?.context?.onCellValidationChange();
    }
  }

  validateCell(): void {
    const fieldName = get(this.params, 'colDef.field');
    const isRowSelected = this.params?.node?.isSelected();
    const requiredExtraFields = get(this.params, 'context.requiredExtraFields', []);
    const isRequiredField = requiredExtraFields.includes(fieldName);
    
    this.isInvalid = isRowSelected && isRequiredField && !this.cellValue;
  }
}
